const firebaseConfig = {
    apiKey: "AIzaSyC5sX_5NBZfWTYidmIGWpy6mR2skzTuvfQ",
    authDomain: "travel-valley.firebaseapp.com",
    projectId: "travel-valley",
    storageBucket: "travel-valley.appspot.com",
    messagingSenderId: "1031979365340",
    appId: "1:1031979365340:web:c848a7e9884460d4651519"
  };

  export default firebaseConfig;